import { render } from "./status-mobile.vue?vue&type=template&id=21f736ff&scoped=true"
import script from "./status-mobile.vue?vue&type=script&lang=js"
export * from "./status-mobile.vue?vue&type=script&lang=js"

import "./status-mobile.vue?vue&type=style&index=0&id=21f736ff&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f736ff"]])

export default __exports__